module.exports = __webpack_public_path__ + "static/media/document-upload.d6e5b1b3.svg";